import InfoLeadReducer from './reducers';

import * as InfoLeadSelectors from './selectors';
import * as InfoLeadTypes from './types';
import * as InfoLeadActions from './actions';
import * as InfoLeadOperations from './operations';

export { InfoLeadSelectors, InfoLeadTypes, InfoLeadActions, InfoLeadOperations };

export default InfoLeadReducer;
